(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["kibbz-catalog-menu"] && !Shopify.designMode) return;
  try {
    const catalogDisclosures = document.querySelectorAll('[data-kibbz-catalog-disclosure]');

  const closeCatalogMenus = (exception) => {
    catalogDisclosures.forEach((details) => {
      if (details !== exception) details.removeAttribute('open');
    });
  };

  catalogDisclosures.forEach((details) => {
    details.addEventListener('toggle', () => {
      const summary = details.querySelector('summary');
      summary?.setAttribute('aria-expanded', details.open ? 'true' : 'false');
      if (details.open) closeCatalogMenus(details);
    });
  });

  document.addEventListener('pointerdown', (event) => {
    if (!event.target.closest('.kibbz-catalog-nav')) closeCatalogMenus();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const openDisclosure = document.querySelector('[data-kibbz-catalog-disclosure][open]');
    if (!openDisclosure) return;
    openDisclosure.removeAttribute('open');
    openDisclosure.querySelector('summary')?.focus();
  });
  } catch(e) { console.error(e); }
})();

})();
